import React from "react"
import { Draggable, DraggableProvided, Droppable, DroppableProvided, DroppableStateSnapshot } from "react-beautiful-dnd"
import { injectIntl } from "react-intl"
import { ConnectedProps, connect } from "react-redux"
import GroupInformation from "../../common/quote/component/GroupInformationComponent"
import { DOCUMENT_TYPE } from "../../state/Constants"
import CalendarEvent from "../../state/calendar-event/CalendarEvent"
import { StockDocumentAttributes } from "../../state/inventory/stockdocument/models"
import { LocationDto } from "../../state/location/Location"
import { GroupDto } from "../../state/pricing/Group"
import { PricingRowDto } from "../../state/pricing/PricingRow"
import { TOOGGLE_DESCRIPTION_TYPE } from "../../state/pricing/ProductDescription"
import RowCustomStatus from "../../state/pricing/rowcustomstatus/RowCustomStatus"
import {
    getPricingTableGroupItemIds,
    getPricingTableTaxByBillingMethod
} from "../../state/pricing/selectors"
import { BILLING_METHOD } from "../../state/product/Types"
import { UserDto } from "../../state/user/User"
import PricingTableItemWrapper from "../PricingTableItemWrapper"

type OwnProps = {
    allItems: PricingRowDto[]
    allowEdit: boolean
    objectId: string
    mainObjectId: string
    mainObject: DOCUMENT_TYPE
    sortable: boolean
    methods: BILLING_METHOD[]
    isDropDisabled: object
    index: number
    tableId: string
    groupId: string
    location: LocationDto
    users: UserDto[]
    documentCalendarEvents: CalendarEvent[]
    fromShowDetails: boolean
    isLimitActive: boolean
    rowCustomStatuses: RowCustomStatus[]
    selectedItemSelectionSet: Set<string>
    showInventoryDetails: boolean
    type: DOCUMENT_TYPE
    productDescription: TOOGGLE_DESCRIPTION_TYPE
    group: GroupDto
    stockDocument:StockDocumentAttributes
    advice: (itemId: string) => object
    triggerSelectAll: (isChecked: boolean, groupId: string, groupIds: string[]) => void
    onUpdate: () => void
    onEditLinkClick: () => void
    documentStatus: string
}

function PricingTableGroup(props: Props) {
    const onUpdateCallback = props.onUpdate
    const onEditLinkClickCallback = props.onEditLinkClick

    return <Draggable key={props.groupId} draggableId={props.groupId} index={props.index}>
        {(provided: DraggableProvided,) => (
            <div
                ref={provided.innerRef}
                {...provided.draggableProps}>

                <div className={"row border-bottom"} key={props.groupId}>
                    <GroupInformation
                        groupItemIds={props.groupItemIds ?? []}
                        allowEdit={props.allowEdit}
                        objectId={props.objectId}
                        mainObjectId={props.mainObjectId}
                        mainObject={props.mainObject}
                        sortable={props.sortable}
                        methods={props.methods}
                        providedDragHandleProps={provided.dragHandleProps}
                        groupId={props.groupId}
                        documentCalendarEvents={props.documentCalendarEvents}
                        type={props.type}
                        onUpdateCallback={onUpdateCallback}
                        isTaxInclusive={props.tax ? props.tax.attributes.isTaxInclusive : false}
                        triggerSelectAll={props.triggerSelectAll}
                    />

                    <Droppable droppableId={props.groupId}
                        isDropDisabled={props.isDropDisabled[props.groupId]}>
                        {(provided: DroppableProvided, snapshot: DroppableStateSnapshot) => (
                            <div
                                id={"sortable-quote-group-" + props.groupId}
                                ref={provided.innerRef}
                                {...provided.droppableProps}
                                className={"group-sortable col-12 pl-5 " + (snapshot.isDraggingOver ? "dnd-highlight" : "")}
                            >
                                {props.groupItemIds.map((itemId, index) => {
                                    return <Draggable key={itemId} draggableId={itemId} index={index}>
                                        {(provided,) => (<div
                                            ref={provided.innerRef}
                                            {...provided.draggableProps}
                                        >
                                            <span {...provided.dragHandleProps}/>
                                            <PricingTableItemWrapper
                                                tableId={props.tableId}
                                                className={props.groupItemIds &&
                                                index === (props.groupItemIds.length - 1) ? "border-0" : ""}
                                                advice={props.advice(itemId)}
                                                onUpdate={onUpdateCallback}
                                                onEditLinkClick={onEditLinkClickCallback}
                                                isBundle={props.allItems.filter(i=>i.attributes.parentId == itemId).length != 0}
                                                key={itemId}
                                                itemId={itemId}
                                                groupId={props.groupId}
                                                dragHandle={provided.dragHandleProps}
                                                currency={props.group?.attributes.currency}
                                                allowEdit={props.allowEdit}
                                                sortable={props.sortable}
                                                location={props.location}
                                                users={props.users}
                                                productDescription={props.productDescription}
                                                showInventoryDetails={props.showInventoryDetails}
                                                type={props.type}
                                                objectId={props.objectId}
                                                mainObjectId={props.mainObjectId}
                                                isLimitActive={props.isLimitActive}
                                                fromShowDetails={props.fromShowDetails}
                                                rowCustomStatuses={props.rowCustomStatuses}
                                                stockDocument={props.stockDocument}
                                                documentStatus={props.documentStatus}
                                            />
                                        </div>)}
                                    </Draggable>
                                })}
                                {props.groupItemIds.length === 0 && !snapshot.isDraggingOver &&
                                    <div className={"row px-3 pt-0 pb-3"}>
                                        <div
                                            className={"col-12 quote-group-empty"}>
                                            <br />
                                        </div>
                                    </div>}
                                {provided.placeholder}
                            </div>
                        )}
                    </Droppable>
                </div>
            </div>
        )}
    </Draggable>
}

const mapState = (state, props: OwnProps) => {
    const objectId = props.mainObjectId
    const groupId = props.groupId
    return {
        ...props,
        groupItemIds: getPricingTableGroupItemIds(state, groupId),
        tax: getPricingTableTaxByBillingMethod(state, BILLING_METHOD.ONE_TIME, objectId),
    }
}
const mapDispatch = {}
const connector = connect(mapState, mapDispatch)
type Props = ConnectedProps<typeof connector>
export default connector(injectIntl(PricingTableGroup))



// WEBPACK FOOTER //
// ./src/pricing/components/PricingTableGroupComponent.tsx